export const OPEN_NOTE_DIALOG = "OPEN_NOTE_DIALOG";
export const CLOSE_NOTE_DIALOG = "CLOSE_NOTE_DIALOG";

export const CREATE_NOTE_REQUEST = "CREATE_NOTE_REQUEST";
export const CREATE_NOTE_SUCCESS = "CREATE_NOTE_SUCCESS";
export const CREATE_NOTE_ERROR = "CREATE_NOTE_ERROR";

export const CHANGE_NOTE = "CHANGE_NOTE";

export const createNote = (siteInspectionId, note, review) => {
  return {
      type: 'CALL_API',
      types: [CREATE_NOTE_REQUEST, CREATE_NOTE_SUCCESS, CREATE_NOTE_ERROR],
      path: `api/note/${siteInspectionId}?review=${review}`,
      method: 'post',
      payload: { text: note },
  };
};

export const updateNote = (siteInspectionId, note, review) => {
  return {
      type: 'CALL_API',
      types: [CREATE_NOTE_REQUEST, CREATE_NOTE_SUCCESS, CREATE_NOTE_ERROR],
      path: `api/note/${siteInspectionId}/${note.id}?review=${review}`,
      method: 'put',
      payload: note,
  };
};

export const closeSiteInspection = (siteInspectionId, note) => {
    return {
        type: 'CALL_API',
        types: [CREATE_NOTE_REQUEST, CREATE_NOTE_SUCCESS, CREATE_NOTE_ERROR],
        path: `api/siteinspection/${siteInspectionId}/close`,
        method: 'put',
        payload: {text: note},
    };
};

export const changeNote = (text, reason) => {
    return {type: CHANGE_NOTE, payload: {text, reason}};
};

export const openNoteDialog = (id, siteInspectionId, note) => {
    return { type: OPEN_NOTE_DIALOG, payload: {id, siteInspectionId, note} };
};

export const closeNoteDialog = () => {
    return { type: CLOSE_NOTE_DIALOG };
};



// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/note.js